import React from 'react';
export function Footer() {
  return <footer className="w-full bg-gray-50 py-8 px-4 border-t border-gray-200" data-id="element-319">
      <div className="max-w-4xl mx-auto" data-id="element-320">
        <div className="mb-6" data-id="element-321">
          <h3 className="text-lg font-semibold text-gray-700 mb-4" data-id="element-322">
            Disclaimer:
          </h3>
          <p className="text-sm text-gray-600" data-id="element-323">
            Neurotoned is a wellness education program and is not intended to
            diagnose, treat, or cure any medical or mental health condition.
            Always consult with a licensed healthcare provider before beginning
            any new wellness program, especially if you are currently in
            treatment or on medication. Neurotoned is not a substitute for
            professional therapy, medical care, or crisis support.
          </p>
        </div>
        <div className="flex flex-wrap justify-center text-sm text-gray-600" data-id="element-324">
          <a href="https://www.neurotoned.com/terms-and-conditions" className="mx-3 hover:text-teal-600 cursor-pointer" data-id="element-325">
            Terms of Service
          </a>
          <a href="https://www.neurotoned.com/privacy-policy" className="mx-3 hover:text-teal-600 cursor-pointer" data-id="element-326">
            Privacy Policy
          </a>
          <span className="mx-3 hover:text-teal-600 cursor-pointer" data-id="element-327">
            Contact: support@neurotoned.com
          </span>
        </div>
        <div className="mt-6 text-center" data-id="element-328">
          <a href="https://www.neurotoned.com" data-id="element-329">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pocHe1GbsyX8jPLCJ2o1Pu/Healing_isn%E2%80%99t_about_forgetting_%E2%80%94_it%E2%80%99s_about_rewiring.-min.png" alt="Neurotoned Logo" className="h-10 w-10 mx-auto mb-2" data-id="element-330" />
          </a>
          <p className="text-sm text-gray-500" data-id="element-331">
            © {new Date().getFullYear()} Neurotoned. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}